<template>
  <div class="auth-wrapper">
    <Login 
      v-if="currentView === 'login'"
      @login-success="handleAuthSuccess"
      @switch-to-register="switchToRegister"
    />
    <Register 
      v-else
      @register-success="handleAuthSuccess"
      @switch-to-login="switchToLogin"
    />
  </div>
</template>

<script>
import Login from './Login.vue'
import Register from './Register.vue'

export default {
  name: 'Auth',
  components: {
    Login,
    Register
  },
  emits: ['auth-success'],
  
  data() {
    return {
      currentView: 'login' // 'login' or 'register'
    }
  },

  methods: {
    switchToRegister() {
      this.currentView = 'register'
    },

    switchToLogin() {
      this.currentView = 'login'
    },

    handleAuthSuccess(authData) {
      this.$emit('auth-success', authData)
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  width: 100%;
  height: 100%;
}
</style>
